import GOVINND from "../assets/team/Aditya.jpg";

export const newsData = [
 {
    id: 1,
    title: "Vysakh's Paper Accepted in Wiley's Journal 'Particle'",
    date: "July 2013",
    summary: "Vysakh's paper has been accepted for publication in Wiley's new journal Particle. Congratulations to Vysakh and co-authors.",
    category: "publication",
    image: "#"
  },
  {
    id: 2,
    title: "Yogita Joins Our Group as CSIR-JRF",
    date: "July 2013",
    summary: "Yogita has joined our group as a CSIR Junior Research Fellow.",
    category: "new member",
    image: "#"
  },
  {
    id: 3,
    title: "Shilpa Joins as M.Tech Trainee from CUSAT",
    date: "July 2013",
    summary: "Shilpa has joined our group as an M.Tech trainee from Cochin University of Science and Technology (CUSAT) for a one-year period.",
    category: "new member",
    image: "#"
  },
  {
    id: 4,
    title: "Group Secures Funding from INDO-DUTCH (DST-NWO) Bilateral Program",
    date: "July 2013",
    summary: "Our group has received funding from the INDO-DUTCH (DST-NWO) bilateral program on 'Functional Materials,' involving collaboration with Technical University of Eindhoven (TU/e), ISM Dhanbad, and CSIR-NCL. The funding will support our research on 'Oxidation Catalysis by Gold.'",
    category: "funding",
    image: "#"
  },
  {
    id: 5,
    title: "Sunil Sekhar Begins Research at University of Lille, France",
    date: "September 2013",
    summary: "As part of his PhD program, Mr. Sunil Sekhar has begun a three-month research stay at the University of Lille, France, working with Dr. Jean-Philippe Dacquin.",
    category: "collaboration",
    image: "#"
  },
  {
    id: 6,
    title: "Sreedhala Wins Best Poster Award at National Science Day",
    date: "February 2014",
    summary: "Sreedhala received the best poster award during National Science Day celebrations. Congratulations to Sreedhala and Sudheesh.",
    category: "award",
    image: "#"
  },
  {
    id: 7,
    title: "Sreedhala & Sudheesh Publish in Nanoscale and Catalysis Today",
    date: "April 2014",
    summary: "Sreedhala and Sudheesh have had papers accepted in Nanoscale and Catalysis Today respectively. Congratulations to both researchers!",
    category: "publication",
    image: "#"
  },
  {
    id: 8,
    title: "New Members Join Cat&MoSS Group",
    date: "July 2014",
    summary: "Ms. Preeti Jain has joined as a PhD student and Ms. Vidhya Lakshmi as an M.Tech project student. We welcome both to the Cat&MoSS group.",
    category: "new member",
    image: "#"
  },
  {
    id: 9,
    title: "Sudheesh Kumar Begins PhD at University of Saskatchewan",
    date: "August 2014",
    summary: "Congratulations to Sudheesh Kumar who has begun his PhD in catalysis at the University of Saskatchewan, Canada. Sudheesh spent three years with Cat&MoSS as both an M.Tech trainee and project assistant.",
    category: "alumni achievement",
    image: "#"
  },
  {
    id: 10,
    title: "Sunil & Vysakh Publish in ChemCatChem and J. Phys Chem C",
    date: "March 2015",
    summary: "Sunil and Vysakh have had papers accepted in ChemCatChem and Journal of Physical Chemistry C respectively. Congratulations to both researchers!",
    category: "publication",
    image: "#"
  },
  {
    id: 11,
    title: "Sreedhala's Paper Accepted in Chemical Communications",
    date: "May 2015",
    summary: "Sreedhala's paper has been accepted in Chemical Communications. Congratulations on this excellent achievement!",
    category: "publication",
    image: "#"
  },
  {
    id: 12,
    title: "Collaborative Work with IISER Pune Published in Scientific Reports",
    date: "May 2015",
    summary: "Our collaborative work with Dr. Vaidhyanathan (IISER Pune) has been accepted for publication in Scientific Reports!",
    category: "publication",
    image: "#"
  },
  {
    id: 13,
    title: "Group Receives DST-Nanomission Funding for Fischer-Tropsch Research",
    date: "August 2015",
    summary: "The group has secured funding from DST-Nanomission to study Fischer-Tropsch catalysts.",
    category: "funding",
    image: "#"
  },
  {
    id: 14,
    title: "Sharad's First Publication in RSC Advances",
    date: "October 2015",
    summary: "Sharad's paper has been accepted in RSC Advances. Congratulations on your first publication!",
    category: "publication",
    image: "#"
  },
  {
    id: 15,
    title: "Anish Publishes in Applied Catalysis A",
    date: "December 2015",
    summary: "Anish's paper has been accepted in Applied Catalysis A. Congratulations and keep up the excellent work!",
    category: "publication",
    image: "#"
  },
  {
    id: 16,
    title: "Vysakh Publishes in Catalysis Science & Technology",
    date: "January 2016",
    summary: "Vysakh's paper has been accepted in Catalysis Science & Technology. Congratulations to all authors for this excellent start to the new year!",
    category: "publication",
    image: "#"
  },
  {
    id: 17,
    title: "Anish Publishes in New Journal of Chemistry",
    date: "January 2016",
    summary: "Anish's paper has been accepted in New Journal of Chemistry. Congratulations to all authors!",
    category: "publication",
    image: "#"
  },
  {
    id: 18,
    title: "Vysakh Publishes in Wiley's ChemistrySelect",
    date: "January 2016",
    summary: "Vysakh's paper has been accepted in Wiley's new journal ChemistrySelect. Congratulations to Vysakh and co-authors.",
    category: "publication",
    image: "#"
  },
  {
    id: 19,
    title: "Sreedhala Publishes in Journal of Catalysis",
    date: "January 2016",
    summary: "Sreedhala's paper has been accepted in the flagship catalysis journal 'Journal of Catalysis'. Congratulations to Sreedhala and Sudheeshkumar!",
    category: "publication",
    image: "#"
  },
  {
    id: 20,
    title: "Sreedhala Receives NCL Research Foundation Award",
    date: "February 2016",
    summary: "Sreedhala has been awarded the NCL Research Foundation Best Research Scholar in Catalysis for 2015. Congratulations!",
    category: "award",
    image: "#"
  },  {
    id: 21,
    title: "NCL Wins SSBC Cricket Tournament at NAL Bangalore",
    date: "February 2016",
    summary: "NCL has won the prestigious Shanti Swarup Bhatnagar Cricket Tournament finals held at NAL Bangalore. Proud to be part of the winning team!",
    category: "achievement",
    image: "#"
  },
  {
    id: 22,
    title: "Sreedhala Presents Research at Netherlands Catalysis Conference",
    date: "March 2016",
    summary: "Sreedhala presented her work at the Netherlands Catalysis and Chemistry Conference (NCCC XVII) in Noordwijkerhout. Acknowledgment to SERB, India for financial support.",
    category: "conference",
    image: "#"
  },
  {
    id: 23,
    title: "Sreedhala Publishes in Applied Catalysis A: General",
    date: "May 2016",
    summary: "Sreedhala's paper has been accepted in Applied Catalysis A: General. Congratulations to Sreedhala, Shruti, and Betsy for this collaborative work.",
    category: "publication",
    image: "#"
  },
  {
    id: 24,
    title: "New PhD Students Join Cat&MoSS Group",
    date: "July 2016",
    summary: "Sumanta and Govind have joined as PhD students. Welcome to both and we wish you a productive time with Cat&MoSS.",
    category: "new member",
    image: "#"
  },
  {
    id: 25,
    title: "Sreedhala Submits PhD Thesis",
    date: "August 2016",
    summary: "Sreedhala has submitted her PhD thesis - the first from Cat&MoSS! Congratulations on this significant milestone.",
    category: "thesis",
    image: "#"
  },
  {
    id: 26,
    title: "Yogita Visits Technical University of Eindhoven for Collaboration",
    date: "September 2016",
    summary: "Yogita is visiting Technical University of Eindhoven, Netherlands for a two-month collaborative research program. Best wishes for this productive visit!",
    category: "collaboration",
    image: "#"
  },
  {
    id: 27,
    title: "Dr. Sreedhala Successfully Defends PhD Thesis",
    date: "December 2016",
    summary: "First PhD from Cat&MoSS! Sreedhala has successfully defended her thesis. Congratulations to Dr. Sreedhala from the entire Cat&MoSS team.",
    category: "thesis",
    image: "#"
  },
  {
    id: 28,
    title: "Vysakh Submits PhD Thesis",
    date: "December 2016",
    summary: "Vysakh has submitted his PhD thesis. Congratulations on reaching this important milestone!",
    category: "thesis",
    image: "#"
  },
  {
    id: 29,
    title: "Sunil Submits PhD Thesis",
    date: "January 2017",
    summary: "Sunil has submitted his PhD thesis. Congratulations on this achievement!",
    category: "thesis",
    image: "#"
  },
  {
    id: 30,
    title: "Anish Publishes in Microporous and Mesoporous Materials",
    date: "January 2017",
    summary: "Anish's paper has been accepted in Microporous and Mesoporous Materials (Elsevier). Congratulations on this publication!",
    category: "publication",
    image: "#"
  },
  {
    id: 31,
    title: "Yogita Publishes in Journal of Physical Chemistry C",
    date: "February 2017",
    summary: "Yogita's paper has been accepted in Journal of Physical Chemistry C. Congratulations on this achievement!",
    category: "publication",
    image: "#"
  },
  {
    id: 32,
    title: "Dr. Vysakh Successfully Defends PhD Thesis",
    date: "March 2017",
    summary: "Vysakh has successfully defended his PhD thesis. Congratulations and best wishes from the entire Cat&MoSS team!",
    category: "thesis",
    image: "#"
  },
  {
    id: 33,
    title: "Dr. Sunil Successfully Defends PhD Thesis",
    date: "April 2017",
    summary: "Sunil has successfully defended his PhD thesis. Cat&MoSS wishes him all the best for a bright future!",
    category: "thesis",
    image: "#"
  },
  {
    id: 34,
    title: "Vysakh Publishes NAPXPS Research in Catalysis Science & Technology",
    date: "August 2017",
    summary: "Vysakh's paper on Near Ambient Pressure XPS (NAPXPS) studies of bimetallic nanoparticles has been accepted in Catalysis Science and Technology. Congratulations!",
    category: "publication",
    image: "#"
  },
  {
    id: 35,
    title: "Group Publishes Book Chapter on Model Nanoparticles in Catalysis",
    date: "August 2017",
    summary: "Our book chapter 'Model Nanoparticles in Catalysis' has been published in Springer's 'Metal Nanoparticles and Clusters'. Congratulations to all contributing authors!",
    category: "publication",
    image: "#"
  },
  {
    id: 36,
    title: "Anish Publishes in Catalysis Communications",
    date: "October 2017",
    summary: "Anish's paper has been accepted in Catalysis Communications. Congratulations on this publication!",
    category: "publication",
    image: "#"
  },
  {
    id: 37,
    title: "Betsy Publishes in Nano-Structures & Nano-Objects",
    date: "November 2017",
    summary: "Betsy's invited paper has been accepted in Elsevier's new journal Nano-Structures & Nano-Objects. Congratulations to all authors!",
    category: "publication",
    image: "#"
  },
  {
    id: 38,
    title: "Anuradha Joins Cat&MoSS as PhD Student",
    date: "January 2018",
    summary: "Anuradha has joined Cat&MoSS as a PhD student. Welcome to the group and best wishes for a successful research journey!",
    category: "new member",
    image: "#"
  },
  {
    id: 39,
    title: "Anish Submits PhD Thesis to AcSIR",
    date: "January 2018",
    summary: "Anish has submitted his thesis to AcSIR for the award of PhD degree. Hearty congratulations from Cat&MoSS!",
    category: "thesis",
    image: "#"
  },
  {
    id: 40,
    title: "Sharad Wins Best Poster Award at National Science Day",
    date: "February 2018",
    summary: "Sharad has won the best poster award during National Science Day celebrations. Congratulations on this achievement!",
    category: "award",
    image: "#"
  },  {
    id: 41,
    title: "Sunil's VIP Article Published in ChemNanoMat",
    date: "April 2018",
    summary: "Sunil's paper has been accepted as a VIP article in ChemNanoMat (Wiley). Congratulations on this prestigious recognition of your excellent work!",
    category: "publication",
    image: "#"
  },
  {
    id: 42,
    title: "Betsy Publishes in ChemCatChem",
    date: "April 2018",
    summary: "Betsy's paper has been accepted in ChemCatChem (Wiley). Congratulations to Betsy and all co-authors for this significant contribution.",
    category: "publication",
    image: "#"
  },
  {
    id: 43,
    title: "Vinod Delivers Invited Talk at OPSR-2018 Conference",
    date: "May 2018",
    summary: "Vinod presented an invited talk at the 'Optics, Photonics and Synchrotron Radiation for Technological Applications' conference (OPSR-2018) organized by BARC Mumbai at RRCAT, Indore.",
    category: "conference",
    image: "#"
  },
  {
    id: 44,
    title: "Sunil's Research Featured in Chemistry Views",
    date: "May 2018",
    summary: "Sunil's paper in ChemNanoMat has been highlighted in Chemistry Views (Wiley), recognizing its significant contribution to the field.",
    category: "recognition",
    image: "#"
  },
  {
    id: 45,
    title: "Dr. Anish Earns PhD Degree",
    date: "July 2018",
    summary: "Anish has been awarded his PhD degree. Congratulations to Dr. Anish from the entire Cat&MoSS team for this accomplishment!",
    category: "thesis",
    image: "#"
  },
  {
    id: 46,
    title: "Yogita Publishes in Chemical Communications",
    date: "September 2018",
    summary: "Yogita's paper has been accepted in Chemical Communications. Congratulations on this excellent contribution to our research portfolio!",
    category: "publication",
    image: "#"
  },
  {
    id: 47,
    title: "Operando XAS Research Published in Journal of Synchrotron Radiation",
    date: "November 2018",
    summary: "Our collaborative work with RRCAT, Indore on operando XAS studies of Fischer-Tropsch catalysts has been published in the Journal of Synchrotron Radiation. Congratulations to all authors!",
    category: "publication",
    image: "#"
  },
  {
    id: 48,
    title: "MAS-NMR Research Published in PCCP",
    date: "November 2018",
    summary: "Our collaborative study with IIST Trivandrum on MAS-NMR analysis of water molecule dynamics in PMOS has been published in Physical Chemistry Chemical Physics (PCCP).",
    category: "publication",
    image: "#"
  },
  {
    id: 49,
    title: "Yogita Submits PhD Thesis to AcSIR",
    date: "December 2018",
    summary: "Yogita has submitted her PhD thesis to AcSIR. Congratulations on reaching this significant milestone in your academic journey!",
    category: "thesis",
    image: "#"
  },
  {
    id: 50,
    title: "Vysakh Publishes in Applied Catalysis A: General",
    date: "January 2019",
    summary: "Vysakh's paper has been accepted in Applied Catalysis A: General. Congratulations to all authors for this valuable contribution to our research portfolio.",
    category: "publication",
    image: "#"
  },
  {
    id: 51,
    title: "Anchal Joins Cat&MoSS as PhD Student",
    date: "January 2019",
    summary: "Anchal has joined Cat&MoSS as a PhD student. Welcome to the team and best wishes for a successful research career with us!",
    category: "new member",
    image: "#"
  },
  {
    id: 52,
    title: "Yogita Wins Best Poster Award at Humboldt Kolleg",
    date: "February 2019",
    summary: "Yogita received the best poster award at the Humboldt Kolleg on Innovation and Entrepreneurship organized by Humboldt Academy Pune. Congratulations on this achievement!",
    category: "award",
    image: "#"
  },
  {
    id: 53,
    title: "Yogita Receives NCL Research Foundation Award in Catalysis",
    date: "February 2019",
    summary: "Yogita has been awarded the Best Research Scholar in Catalysis by NCL Research Foundation, becoming the second Cat&MoSS member after Sreedhala to receive this honor.",
    category: "award",
    image: "#"
  },
  {
    id: 54,
    title: "Preeti Publishes in ChemistrySelect",
    date: "February 2019",
    summary: "Preeti's paper has been accepted in ChemistrySelect. Congratulations to Preeti and her collaborators for this research contribution.",
    category: "publication",
    image: "#"
  },
  {
    id: 55,
    title: "Dr. Anish Accepts Postdoctoral Position at University of Southampton",
    date: "April 2019",
    summary: "Anish has accepted a postdoctoral position at the University of Southampton and will be relocating to the UK. Cat&MoSS acknowledges his valuable contributions and wishes him success in this new chapter.",
    category: "alumni achievement",
    image: "#"
  },
  {
    id: 56,
    title: "Dr. Subha PV Joins as SERB-National Postdoctoral Fellow",
    date: "April 2019",
    summary: "We welcome Dr. Subha PV who has joined our group as a SERB-National Postdoctoral Fellow. Best wishes for a productive and successful research tenure with us!",
    category: "new member",
    image: "#"
  },
  {
    id: 57,
    title: "Dr. Yogita Successfully Defends PhD Thesis",
    date: "May 2019",
    summary: "Yogita has successfully defended her PhD thesis. Congratulations to Dr. Yogita from the entire Cat&MoSS team for this outstanding achievement!",
    category: "thesis",
    image: "#"
  },
  {
    id: 58,
    title: "Collaborative Research Published in ACS Sustainable Chemistry & Engineering",
    date: "September 2019",
    summary: "Our collaborative work with Prof. Ali Haider (IIT Delhi) has been published in ACS Sustainable Chemistry & Engineering. Congratulations to Govind, Sreedhala, and Joes for this achievement!",
    category: "publication",
    image: "#"
  },
  {
    id: 59,
    title: "Sharad Submits PhD Thesis to AcSIR",
    date: "October 2019",
    summary: "Sharad has submitted his PhD thesis to AcSIR. Congratulations on reaching this significant academic milestone!",
    category: "thesis",
    image: "#"
  },
  {
    id: 60,
    title: "Preeti Submits PhD Thesis to AcSIR",
    date: "November 2019",
    summary: "Preeti has submitted her PhD thesis to AcSIR. Congratulations on this important achievement in your academic career!",
    category: "thesis",
    image: "#"
  },  {
    id: 61,
    title: "Betsy Wins Best Oral Presentation Award at NCL-RF Conference",
    date: "November 2019",
    summary: "Betsy received the Best Oral Presentation Award at the NCL Research Foundation Student Conference. Congratulations on this outstanding achievement!",
    category: "award",
    image: "#"
  },
  {
    id: 62,
    title: "Preeti Wins Second Prize at ICAFM-2019 International Conference",
    date: "December 2019",
    summary: "Preeti secured second prize for her oral presentation at the International Conference on Advanced Functional Materials (ICAFM-2019) at NIIST Trivandrum. Well-deserved recognition!",
    category: "award",
    image: "#"
  },
  {
    id: 63,
    title: "Collaborative Research with University of Lille Published in Applied Materials Today",
    date: "January 2020",
    summary: "Our collaborative work with Prof. Jean-Philippe Dacquin (UCCS, Lille) has been published in Applied Materials Today. Congratulations to Sharad and all co-authors!",
    category: "publication",
    image: "#"
  },
  {
    id: 64,
    title: "Sanket Joins Cat&MoSS as CSIR-JRF",
    date: "January 2020",
    summary: "Sanket has joined our group as a CSIR Junior Research Fellow. Welcome to Cat&MoSS and best wishes for a productive research journey!",
    category: "new member",
    image: "#"
  },
  {
    id: 65,
    title: "Sumanta Receives Best Poster Award at National Science Day",
    date: "February 2020",
    summary: "Sumanta won the Best Poster Prize during National Science Day celebrations at NCL. Congratulations on this recognition of your research!",
    category: "award",
    image: "#"
  },
  {
    id: 66,
    title: "Research Published in Applied Catalysis B: Environmental",
    date: "March 2020",
    summary: "Our work has been published in Applied Catalysis B: Environmental (Impact Factor: 16.68). Congratulations to Yogita, Sumanta, and Mahesh, with thanks to collaborators at RRCAT Indore, BARC Mumbai, and IIT Delhi.",
    category: "publication",
    image: "#"
  },
  {
    id: 67,
    title: "Preeti Publishes in Nano-Structures & Nano-Objects",
    date: "June 2020",
    summary: "Preeti's paper has been accepted in Nano-Structures and Nano-Objects (Elsevier). Congratulations to Preeti and Sharad for this excellent contribution!",
    category: "publication",
    image: "#"
  },
  {
    id: 68,
    title: "Dr. Sharad Gupta Successfully Defends PhD Thesis",
    date: "July 2020",
    summary: "Sharad has successfully defended his PhD thesis. Congratulations to Dr. Sharad Gupta from the entire Cat&MoSS team! We wish you continued success in your academic career.",
    category: "thesis",
    image: "#"
  },
  {
    id: 69,
    title: "Dr. Preeti Jain Successfully Defends PhD Thesis",
    date: "July 2020",
    summary: "Preeti has successfully defended her PhD thesis. Hearty congratulations to Dr. Preeti Jain from Cat&MoSS for this accomplishment!",
    category: "thesis",
    image: "#"
  },
  {
    id: 70,
    title: "Research Published in ACS Sustainable Chemistry & Engineering",
    date: "September 2020",
    summary: "Congratulations to Betsy, Anish, and Anjuna for publishing their collaborative work in ACS Sustainable Chemistry & Engineering!",
    category: "publication",
    image: "#"
  },
  {
    id: 71,
    title: "Govind Receives Indian Chemical Society Research Excellence Award",
    date: "December 2020",
    summary: "Govind has been awarded the Indian Chemical Society Research Excellence Award for his oral presentation on phenol hydrogenation mechanisms at the 57th Annual Convention of Chemists.",
    category: "award",
    image: "#"
  },
  {
    id: 72,
    title: "Govind Receives Keerthi Sangoram Memorial Endowment Award",
    date: "February 2021",
    summary: "Govind has been honored with the NCL Research Foundation's Keerthi Sangoram Memorial Endowment Award for Best Research Scholar in Catalysis (2020). Congratulations!",
    category: "award",
    image: "#"
  },
  {
    id: 73,
    title: "Yogita Receives Paul Ratnasamy & Suneeta Kulkarni Award",
    date: "February 2021",
    summary: "Yogita has been awarded the Dr. Paul Ratnasamy & Dr. Suneeta B. Kulkarni Award for Best Research Publication in Catalysis (Applied Catalysis B: Environmental, IF:16) during National Science Day celebrations.",
    category: "award",
    image: "#"
  },
  {
    id: 74,
    title: "Yogita Publishes in Molecular Catalysis",
    date: "July 2021",
    summary: "Yogita's paper has been accepted in Molecular Catalysis. Congratulations to all authors for this research contribution!",
    category: "publication",
    image: "#"
  },
  {
    id: 75,
    title: "Preeti Publishes in Materials Today Sustainability",
    date: "September 2021",
    summary: "Preeti's work has been published in Materials Today Sustainability. Congratulations on this excellent contribution to sustainable materials research!",
    category: "publication",
    image: "#"
  },
  {
    id: 76,
    title: "Dr. Yogita Begins Postdoc at Tufts University",
    date: "September 2021",
    summary: "Yogita has joined Dr. Prashant Deshlahra's research group at Tufts University as a postdoctoral fellow. Congratulations and best wishes for this new chapter!",
    category: "alumni achievement",
    image: "#"
  },
  {
    id: 77,
    title: "Govind Submits PhD Thesis to AcSIR",
    date: "December 2021",
    summary: "Govind has submitted his PhD thesis to AcSIR. Congratulations on reaching this significant academic milestone!",
    category: "thesis",
    image: "#"
  },
  {
    id: 78,
    title: "Betsy Submits PhD Thesis to AcSIR",
    date: "January 2022",
    summary: "Betsy has submitted her PhD thesis to AcSIR. Congratulations on this important achievement in your research career!",
    category: "thesis",
    image: "#"
  },
  {
    id: 79,
    title: "Dr. Sharad Gupta Joins ULCO Dunkerque as Postdoc",
    date: "March 2022",
    summary: "Sharad has begun a postdoctoral position at Université du Littoral Côte d'Opale (ULCO), France, working with Prof. Christophe Poupin. Best wishes for this new endeavor!",
    category: "alumni achievement",
    image: "#"
  },
  {
    id: 80,
    title: "Dr. Govind Successfully Defends PhD Thesis",
    date: "April 2022",
    summary: "Govind has successfully defended his PhD thesis. Congratulations to Dr. Govind from the entire Cat&MoSS team!",
    category: "thesis",
    image: "#"
  },
  {
    id: 81,
    title: "Dr. K.J. Betsy Successfully Defends PhD Thesis",
    date: "April 2022",
    summary: "Betsy has successfully defended her PhD thesis. Hearty congratulations to Dr. K.J. Betsy from Cat&MoSS!",
    category: "thesis",
    image: "#"
  },
  {
    id: 82,
    title: "Dr. Preeti Jain Joins KU Center for Beneficial Catalysis",
    date: "June 2022",
    summary: "Preeti has joined the KU Center for Environmentally Beneficial Catalysis at Kansas State University, USA. Congratulations on this exciting opportunity!",
    category: "alumni achievement",
    image: "#"
  },
  {
    id: 83,
    title: "Dr. Anish Joins IS2M Mulhouse for Postdoctoral Research",
    date: "June 2022",
    summary: "Anish has begun his second postdoctoral position at IS2M Mulhouse, France. Best wishes for this new phase of your research career!",
    category: "alumni achievement",
    image: "#"
  },
  {
    id: 84,
    title: "Dr. Betsy Awarded Postdoc at Denmark Technical University",
    date: "July 2022",
    summary: "Betsy has been awarded a postdoctoral fellowship at Denmark Technical University (DTU). Congratulations and best wishes for your future research endeavors!",
    category: "alumni achievement",
    image: "#"
  }
];